import { render, staticRenderFns } from "./Replacementofrecords.vue?vue&type=template&id=576d0da4&scoped=true&"
import script from "./Replacementofrecords.vue?vue&type=script&lang=js&"
export * from "./Replacementofrecords.vue?vue&type=script&lang=js&"
import style0 from "./Replacementofrecords.vue?vue&type=style&index=0&id=576d0da4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576d0da4",
  null
  
)

export default component.exports